(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/common/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/casino-react/common/assets/javascripts/constants.js');

'use strict';

const CasinoGamePlayTypes = {
  demoPlay: 'provspela',
  gamePlay: 'spela'
};
const CardType = Object.freeze({
  GAME: 'cardtype-game',
  PROVIDER: 'cardtype-provider',
  CATEGORY: 'cardtype-category'
});
const CasinoDisplaySize = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});
const GridDisplayModes = Object.freeze({
  GRID_RESTRICTED: 'gridRestricted',
  GRID_RESTRICTED_DOUBLE_ROW: 'gridRestrictedDoubleRow',
  GRID_UNRESTRICTED: 'gridUnrestricted',
  GRID_TALL: 'gridTall'
});
const GridRulesets = Object.freeze({
  [GridDisplayModes.GRID_RESTRICTED]: {
    classList: ['restricted', 'showcase'],
    childClassList: [],
    maxItems: {
      [CasinoDisplaySize.SMALL]: 4,
      [CasinoDisplaySize.MEDIUM]: 3,
      [CasinoDisplaySize.LARGE]: 4
    },
    isTall: false
  },
  [GridDisplayModes.GRID_RESTRICTED_DOUBLE_ROW]: {
    classList: [],
    childClassList: [],
    maxItems: {
      [CasinoDisplaySize.SMALL]: 8,
      [CasinoDisplaySize.MEDIUM]: 6,
      [CasinoDisplaySize.LARGE]: 8
    },
    isTall: false
  },
  [GridDisplayModes.GRID_UNRESTRICTED]: {
    classList: ['unrestricted', 'showcase'],
    childClassList: [],
    maxItems: undefined,
    isTall: false
  },
  [GridDisplayModes.GRID_TALL]: {
    classList: [],
    childClassList: ['casino-grid__item--tall'],
    maxItems: {
      [CasinoDisplaySize.SMALL]: 2,
      [CasinoDisplaySize.MEDIUM]: 3,
      [CasinoDisplaySize.LARGE]: 4
    },
    isTall: true
  }
});
const DefaultNumberOfCasinoGridItems = 12; 

const MAX_LAST_SEARCHED = 12;
const MAX_LAST_PLAYED = 12;
const exported = {
  DefaultNumberOfCasinoGridItems,
  CasinoDisplaySize,
  GridDisplayModes,
  GridRulesets,
  CardType,
  CasinoGamePlayTypes,
  MAX_LAST_SEARCHED,
  MAX_LAST_PLAYED
};
if (svs.isServer) {
  module.exports = exported;
} else {
  setGlobal('svs.components.casino_react.common.constants', exported);
}

 })(window);